import React, { useEffect } from 'react';
import EventLabel from '../../components/EventLabel/EventLabel';
import cn from 'classnames';

interface ConfirmationSnackbarProps {
  open: boolean;
  onClose: () => void;
  message: string;
}

export function ConfirmationSnackbar({ open, onClose, message }: ConfirmationSnackbarProps) {
  const [isOpen, setIsOpen] = React.useState(open);

  const timeoutRef = React.useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (open) {
      setIsOpen(true);
      timeoutRef.current = setTimeout(() => {
        setIsOpen(false);
        onClose();
      }, 2000); // Auto close after 2 seconds

      return () => {
        clearTimeout(timeoutRef.current!);
        setIsOpen(false);
      };
    }
  }, [open]);

  return (
    <div
      className={cn(
        `
         absolute  left-1/2 transform -translate-x-1/2 transition-opacity duration-300 ease-in-out z-50`,
        isOpen ? 'opacity-100 -translate-y-16' : 'opacity-0  -translate-y-[1000px] fixed z-0'
      )}
      onClick={onClose}
    >
      <div className="pb-2.5 bg-success text-white dark:text-white pt-2 px-3 rounded shadow-lg flex items-center gap-2 justify-between">
        
        <i className="ri-check-line text-xl pt-1" />
        <span className='w-48 md:w-fit'>
          <EventLabel name={message} groupName="CMS.GroupModule" />
        </span>
      </div>
    </div>
  );
}
